﻿export const getSatser = async (): Promise<Satser> => {
    const response = await fetch('/api/mt1535/satser/inntektsavhengigstipend');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface Satser {
    ST01_BehovsprovingNedreInntektsgrenseGrunnstipendTabellA: number;
    ST01_BehovsprovingNedreInntektsgrenseGrunnstipendTabellB: number;
    ST01_BehovsprovingTilleggInntektNyPartner: number;
    ST01_BehovsprovingGrunnstipendTrinnInntekt: number;
    ST01_KompensasjonPerBarnGrunnstipend: number;
    ST01_GrunnstipendTrinn1: number;
    ST01_GrunnstipendTrinn2: number;
    ST01_GrunnstipendTrinn3: number;
    NullKroner: number;
}
